<div class="row">
  <div class="col-12">

    <div [ngSwitch]="confirmationCodeFormComponent.submitConfirmationCodeErrorType">
      <div *ngSwitchDefault [@submittedConfirmationCodeAlert]>
        <div class="alert alert-success mb-4 py-4" role="alert" >
          <span>If the email address you entered is associated with an account and verified,
            we will send an email message containing a confirmation code.</span>
        </div>
      </div>

      <div *ngSwitchCase="'INVALID_CODE'" [@submittedConfirmationCodeAlert]>
        <div class="alert alert-danger mb-4 py-4" role="alert" >
          <span>The confirmation code you have entered is incorrect. Please check your email and try again.</span>
        </div>
      </div>

      <div *ngSwitchCase="'GENERIC_ERROR'" [@submittedConfirmationCodeAlert]>
        <div class="alert alert-danger mb-4 py-4" role="alert" >
          <p>We encountered an issue completing your request.</p>
          <span>Please contact Customer Service at {{ customerServicePhone }}.</span>
        </div>
      </div>
    </div>


    <app-submit-confirmation-code-form #confirmationCodeFormComponent [username]="username">
    </app-submit-confirmation-code-form>

    <div class="row mb-2">
      <div class="col-12 d-flex">
        <span class="ml-auto">Haven’t received your email? <a id="resendVerificationEmailLink" href=""
          (click)="resendVerificationEmail(confirmationCodeFormComponent); false;">Resend Verification Email</a></span>
      </div>
    </div>

    <div *ngIf="resendVerificationEmailButtonClicked" [@showVerificationCodeResentMessage]>
      <div class="row">
        <div class="col-12 d-flex">
          <small class="ml-auto"><strong>Verification email has been resent.</strong></small>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex">
          <small class="ml-auto">Still having trouble? Please contact us at {{ customerServicePhone }}.</small>
        </div>
      </div>
    </div>

  </div>
</div>
